import { useEffect, useState } from "react";
import { api } from "../lib/api";

export const useSiteConfig = () => {
  const [config, setConfig] = useState(null);
  useEffect(() => {
    api.get("/config").then((r) => setConfig(r.data)).catch(() => setConfig(null));
  }, []);
  return config;
};
